module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"notice_detail":"お知らせの詳細を見る"}}')
  delete Component.options._Ctor
}
